import ServiceBase from './serviceBase';
import { User } from './types/User';
import { UserQuery } from '../containers/Operations/Operation/UserQueryReducer';
import { OpMember } from './types/Member';

class UserService extends ServiceBase {
  getUsers = async (filter: UserQuery): Promise<User[]> => {
    if (!filter.query || !filter.query.trim()) {
      return [];
    }
    return this.get<User[]>(
      `users/search/${filter.convergence}/${filter.query}/${filter.includeGS}`
    );
  };

  picture = async (): Promise<string | null> => this.getBinary('users/photo');

  getMembers = async (filter: { query: string }): Promise<OpMember[]> => {
    if (!filter.query || !filter.query.trim()) {
      return [];
    }
    return this.get<OpMember[]>(`users/searchmembers/${filter.query}`);
  };
}

const userService = new UserService();

export default userService;
